__turbopack_context__.v({
  "contactForm": "contact-module-scss-module__csZEva__contactForm",
  "contactFormContainer": "contact-module-scss-module__csZEva__contactFormContainer",
  "contactWrapper": "contact-module-scss-module__csZEva__contactWrapper",
  "container": "contact-module-scss-module__csZEva__container",
  "error": "contact-module-scss-module__csZEva__error",
  "fontColor_error": "contact-module-scss-module__csZEva__fontColor_error",
  "fontColor_mainDarkest": "contact-module-scss-module__csZEva__fontColor_mainDarkest",
  "fontColor_mainLightest": "contact-module-scss-module__csZEva__fontColor_mainLightest",
  "fontColor_mainPrimary": "contact-module-scss-module__csZEva__fontColor_mainPrimary",
  "fontColor_mainSecondary": "contact-module-scss-module__csZEva__fontColor_mainSecondary",
  "fontColor_neutralDark": "contact-module-scss-module__csZEva__fontColor_neutralDark",
  "fontColor_neutralLight": "contact-module-scss-module__csZEva__fontColor_neutralLight",
  "fontColor_neutralMedium": "contact-module-scss-module__csZEva__fontColor_neutralMedium",
  "formField": "contact-module-scss-module__csZEva__formField",
  "indicator": "contact-module-scss-module__csZEva__indicator",
  "required": "contact-module-scss-module__csZEva__required",
  "selectWrapper": "contact-module-scss-module__csZEva__selectWrapper",
  "stylizedSelect_selectWrapper": "contact-module-scss-module__csZEva__stylizedSelect_selectWrapper",
  "submitButton": "contact-module-scss-module__csZEva__submitButton",
  "successMessage": "contact-module-scss-module__csZEva__successMessage",
});
